module.exports = __webpack_public_path__ + "static/digital-technology-services-d7d0d0dfcab0f0490a88ca74936fc5b5.jpg";